(function () {
  "use strict";

  var rootPath =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  function getCartRoot(element) {
    return (
      element.closest("[data-tuya-cart-root]") ||
      element.querySelector("[data-tuya-cart-root]") ||
      document.querySelector("[data-tuya-cart-root]")
    );
  }

  function getContainer(element) {
    return element.closest("cart-items-component");
  }

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    cents = parseInt(cents, 10) || 0;

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) return cents.toString();

    var formatKey = match[1];

    switch (formatKey) {
      case "amount":
        value = (cents / 100)
          .toFixed(2)
          .replace(/\./, ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1\u00a0");
        break;
      case "amount_no_decimals":
        value = Math.round(cents / 100)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1\u00a0");
        break;
      case "amount_with_comma_separator":
        value = (cents / 100)
          .toFixed(2)
          .replace(/\./, ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = Math.round(cents / 100)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        break;
      default:
        value = (cents / 100).toFixed(2);
    }

    return format.replace(placeholderRegex, value);
  }

  function recalculateSummary(cartRoot) {
    if (!cartRoot) return;

    var container =
      cartRoot.closest("cart-items-component") ||
      cartRoot.parentElement.querySelector("cart-items-component");
    if (!container) {
      container = document.querySelector("cart-items-component");
    }
    if (!container) return;

    var moneyFormat = cartRoot.dataset.moneyFormat || "{{amount}} zł";
    var freeShippingThreshold =
      parseInt(cartRoot.dataset.freeShippingThreshold, 10) || 0;
    var textFreeShippingSuccess =
      cartRoot.dataset.textFreeShippingSuccess || "";
    var textFreeShippingMissing =
      cartRoot.dataset.textFreeShippingMissing || "";
    var textFreeShippingReached =
      cartRoot.dataset.textFreeShippingReached || "";
    var textFreeShippingLimit = cartRoot.dataset.textFreeShippingLimit || "";
    var textDeliveryFree = cartRoot.dataset.textDeliveryFree || "";
    var textDeliveryCalculated = cartRoot.dataset.textDeliveryCalculated || "";
    var textVat = cartRoot.dataset.textVat || "";
    var textProductsValue = cartRoot.dataset.textProductsValue || "";

    var itemCards = container.querySelectorAll(".tuya-cart__item-card");
    var selectedTotal = 0;
    var selectedOriginal = 0;
    var selectedDiscount = 0;
    var selectedCount = 0;

    itemCards.forEach(function (card) {
      var checkbox = card.querySelector(".tuya-cart-item-checkbox");
      if (!checkbox || !checkbox.checked) return;

      selectedTotal += parseInt(card.dataset.finalLinePrice, 10) || 0;
      selectedOriginal += parseInt(card.dataset.originalLinePrice, 10) || 0;
      selectedDiscount += parseInt(card.dataset.discountAmount, 10) || 0;
      selectedCount += parseInt(card.dataset.quantity, 10) || 0;
    });

    var productsLabel = cartRoot.querySelector(
      "[data-tuya-summary-products-label]",
    );
    if (productsLabel) {
      productsLabel.textContent =
        textProductsValue + " (" + selectedCount + ")";
    }

    var productsValue = cartRoot.querySelector(
      "[data-tuya-summary-products-value]",
    );
    if (productsValue) {
      productsValue.textContent = formatMoney(selectedOriginal, moneyFormat);
    }

    var discountRow = cartRoot.querySelector("[data-tuya-summary-discount]");
    if (discountRow) {
      var discountValue = discountRow.querySelector(
        "[data-tuya-summary-discount-value]",
      );
      if (discountValue) {
        discountValue.textContent =
          "-" + formatMoney(selectedDiscount, moneyFormat);
      }
    }

    var totalPriceEl = cartRoot.querySelector(
      "[data-tuya-summary-total-price]",
    );
    if (totalPriceEl) {
      totalPriceEl.textContent = formatMoney(selectedTotal, moneyFormat);
    }

    var vatEl = cartRoot.querySelector("[data-tuya-summary-vat]");
    if (vatEl) {
      var vatAmount = Math.round((selectedTotal * 23) / 123);
      var vatFormatted = formatMoney(vatAmount, moneyFormat);
      vatEl.textContent = textVat.replace("[amount]", vatFormatted);
    }

    var isFreeShipping = selectedTotal >= freeShippingThreshold;

    var deliveryRow = cartRoot.querySelector("[data-tuya-summary-delivery]");
    if (deliveryRow) {
      if (isFreeShipping) {
        deliveryRow.classList.add("tuya-cart__summary-card-row--promo");
      } else {
        deliveryRow.classList.remove("tuya-cart__summary-card-row--promo");
      }
      var deliveryValue = deliveryRow.querySelector(
        "[data-tuya-summary-delivery-value]",
      );
      if (deliveryValue) {
        deliveryValue.textContent = isFreeShipping
          ? textDeliveryFree
          : textDeliveryCalculated;
      }
    }

    var promoTitle = cartRoot.querySelector("[data-tuya-promo-title]");
    if (promoTitle) {
      if (isFreeShipping) {
        promoTitle.textContent = textFreeShippingSuccess;
      } else {
        var missingAmount = freeShippingThreshold - selectedTotal;
        var missingFormatted = formatMoney(missingAmount, moneyFormat);
        promoTitle.textContent = textFreeShippingMissing.replace(
          "[amount]",
          missingFormatted,
        );
      }
    }

    var promoFill = cartRoot.querySelector("[data-tuya-promo-fill]");
    if (promoFill) {
      var progress =
        freeShippingThreshold > 0
          ? Math.min(
              100,
              Math.round((selectedTotal * 100) / freeShippingThreshold),
            )
          : 100;
      promoFill.style.width = progress + "%";
    }

    var promoCurrent = cartRoot.querySelector("[data-tuya-promo-current]");
    if (promoCurrent) {
      promoCurrent.textContent = formatMoney(selectedTotal, moneyFormat);
    }

    var promoStatus = cartRoot.querySelector("[data-tuya-promo-status]");
    if (promoStatus) {
      if (isFreeShipping) {
        promoStatus.textContent = textFreeShippingReached;
        promoStatus.classList.add("tuya-cart__promo-bar-success");
      } else {
        var thresholdValue = freeShippingThreshold / 100;
        promoStatus.textContent = textFreeShippingLimit.replace(
          "[limit]",
          thresholdValue,
        );
        promoStatus.classList.remove("tuya-cart__promo-bar-success");
      }
    }
  }

  function removeItemsByKeys(keys, container) {
    var cartItemsComponent = getContainer(container);
    var sectionId = cartItemsComponent
      ? cartItemsComponent.dataset.sectionId
      : null;

    if (cartItemsComponent) {
      cartItemsComponent.classList.add("cart-items-disabled");
    }

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    var body = { updates: updates };

    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    fetch(rootPath + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: cart },
          }),
        );

        if (sectionId && cart.sections && cart.sections[sectionId]) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(
            cart.sections[sectionId],
            "text/html",
          );
          var newComponent = doc.querySelector("cart-items-component");
          if (newComponent && cartItemsComponent) {
            cartItemsComponent.innerHTML = newComponent.innerHTML;
            syncSelectAllState(cartItemsComponent);
          } else {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function syncSelectAllState(container) {
    var selectAllCheckbox = container.querySelector(".tuya-cart-select-all");
    var itemCheckboxes = container.querySelectorAll(".tuya-cart-item-checkbox");
    if (!selectAllCheckbox || itemCheckboxes.length === 0) return;

    var checkedCount = 0;
    itemCheckboxes.forEach(function (cb) {
      if (cb.checked) checkedCount++;
    });
    selectAllCheckbox.checked = checkedCount === itemCheckboxes.length;
    selectAllCheckbox.indeterminate =
      checkedCount > 0 && checkedCount < itemCheckboxes.length;
  }

  document.addEventListener("change", function (e) {
    var target = e.target;

    if (target.classList.contains("tuya-cart-select-all")) {
      var container = getContainer(target);
      if (!container) return;
      var isChecked = target.checked;
      var itemCheckboxes = container.querySelectorAll(
        ".tuya-cart-item-checkbox",
      );
      itemCheckboxes.forEach(function (cb) {
        cb.checked = isChecked;
      });

      recalculateSummary(getCartRoot(container));
      return;
    }

    if (target.classList.contains("tuya-cart-item-checkbox")) {
      var container = getContainer(target);
      if (!container) return;
      syncSelectAllState(container);

      recalculateSummary(getCartRoot(container));
    }
  });

  document.addEventListener("click", function (e) {
    var toggleBtn = e.target.closest(".tuya-cart__bundle-toggle-btn");
    if (toggleBtn) {
      e.preventDefault();
      var bundleGroup = toggleBtn.closest(".tuya-cart__bundle-group");
      if (bundleGroup) {
        var isCollapsed = bundleGroup.classList.toggle(
          "tuya-cart__bundle-group--collapsed",
        );
        toggleBtn.setAttribute("aria-expanded", !isCollapsed);
        var labelSpan = toggleBtn.querySelector(".tuya-cart__bundle-toggle-label");
        var showText = toggleBtn.getAttribute("data-show-text");
        var hideText = toggleBtn.getAttribute("data-hide-text");
        if (labelSpan) {
          labelSpan.textContent = isCollapsed ? showText : hideText;
        }
      }
      return;
    }

    var deleteSelectedBtn = e.target.closest(".tuya-cart-delete-selected");
    if (deleteSelectedBtn) {
      e.preventDefault();
      var container = getContainer(deleteSelectedBtn);
      if (!container) return;
      var checkedBoxes = container.querySelectorAll(
        ".tuya-cart-item-checkbox:checked",
      );
      if (checkedBoxes.length === 0) return;

      var keys = [];
      checkedBoxes.forEach(function (cb) {
        if (cb.dataset.key) keys.push(cb.dataset.key);
      });
      if (keys.length > 0) {
        removeItemsByKeys(keys, container);
      }
      return;
    }

    var clearCartBtn = e.target.closest(".tuya-cart-clear-all");
    if (clearCartBtn) {
      e.preventDefault();
      var container = getContainer(clearCartBtn);
      if (!container) return;
      var itemCheckboxes = container.querySelectorAll(
        ".tuya-cart-item-checkbox",
      );
      var allKeys = [];
      itemCheckboxes.forEach(function (cb) {
        if (cb.dataset.key) allKeys.push(cb.dataset.key);
      });
      if (allKeys.length > 0) {
        removeItemsByKeys(allKeys, container);
      }
    }
  });

  var syncTimer = null;
  var observer = new MutationObserver(function () {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var containers = document.querySelectorAll("cart-items-component");
      containers.forEach(function (container) {
        syncSelectAllState(container);
      });
    }, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  var cartRoot = document.querySelector("[data-tuya-cart-root]");
  if (cartRoot) {
    recalculateSummary(cartRoot);
  }
})();
